// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerRelative:host .pageHeader {
  position: relative !important;
  padding: 0;
  background: transparent;
}

:host {
  position: fixed;
  top: 0;
  width: 100vw;
  min-height: 12vh;
  background: transparent;
  z-index: 999;
}

.blurrer {
  transform: translateY(0);
  opacity: 1;
  transition: all 0.3s ease-in-out;
  backdrop-filter: blur(15px);
  width: 100vw;
  display: block;
  position: fixed;
  top: 0vw;
  left: 0;
  z-index: 99;
  -webkit-backdrop-filter: blur(15px);
  mask-image: linear-gradient(to bottom, black 0%, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 50%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 0%, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 50%, transparent 100%);
}

.pageHeader {
  background: transparent;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  width: 100vw;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  transition: all 0.3s ease-in-out;
  border-radius: 0;
  padding-top: env(safe-area-inset-top);
}
.pageHeader .headerBox {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  transition: all 0.3s ease-in-out;
  z-index: 999;
}
.pageHeader .headerBox .pageHeaderTitle {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  width: 100%;
  color: var(--ion-text-primary);
  text-align: center;
  padding: 0 10vw 0vw 0vw;
  height: 6vh;
}
.pageHeader .headerBox .pageHeaderTitle .pageHeaderContent {
  transition: all 0.3s ease-in-out;
  font-size: 20px;
}
.pageHeader .headerBox .pageHeaderBack {
  position: relative;
  transition: all 0.3s ease-in-out;
}
.pageHeader .headerBox .pageHeaderSoloTitle {
  margin: 0 10vw 0vw 0vw;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: row;
  cursor: pointer;
  position: relative;
  pointer-events: auto;
  z-index: 3;
  flex: 1;
}
.pageHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainer {
  background: linear-gradient(180deg, var(--ion-more-primary) 0%, var(--ion-half-primary) 50%, var(--ion-clear-primary) 100%);
  background-repeat: no-repeat;
  background-position: 0 100%;
  transition: all 0.3s ease-in-out;
  transform-origin: center;
  padding: 0;
  border-radius: 30px;
  height: 4vh;
}
.pageHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainer .pageHeaderSoloContent {
  position: relative;
  display: flex;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  letter-spacing: 1px;
  font-weight: 500;
  font-size: 20px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all 0.3s ease-in-out;
  padding: 1vw 5vw;
  min-width: 60vw;
  justify-content: center;
  align-items: center;
}
.pageHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainerBig {
  background: transparent;
  transition: all 0.3s ease-in-out;
  padding: 0;
  border-radius: 30px;
  height: 4vh;
  position: absolute;
  top: 0;
  transform-origin: center;
}
.pageHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainerBig .pageHeaderSoloContent {
  position: relative;
  display: flex;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  letter-spacing: 1px;
  font-weight: 500;
  font-size: 20px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all 0.3s ease-in-out;
  padding: 1vw 2vw;
}
.pageHeader .headerBox .groupHeaderBack {
  position: relative;
  transition: all 0.3s ease-in-out;
}
.pageHeader .groupHeading {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: calc(100vw - 2vh);
  text-align: center;
  z-index: 998;
  margin: 1vh;
  gap: 1vh;
  transition: all 0.3s ease-in-out;
}
.pageHeader .groupHeading .groupHeaderBack {
  position: relative;
  transition: all 0.3s ease-in-out;
}
.pageHeader .groupHeading .groupHeadingTitle {
  max-width: 75vw;
  width: 100%;
  height: 5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: row;
  cursor: pointer;
  position: relative;
  pointer-events: auto;
  z-index: 3;
  backdrop-filter: blur(5px) brightness(0.9) saturate(120%) contrast(1.3);
  transition: all 0.3s ease-in-out;
}
.pageHeader .groupHeading .groupHeadingTitle .buttonText {
  position: relative;
  display: flex;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  letter-spacing: 1px;
  font-weight: 500;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all 0.3s ease-in-out;
  padding: 1vw 2vw;
}
.pageHeader .groupHeading .groupHeadingTitle .count {
  border-radius: 20px;
  padding: 0 2vw;
  margin: 0 2vw;
}
.pageHeader .groupHeading .activeList {
  background-position: 0 0%;
  box-shadow: var(--shadow-glass-anim-end), inset -0.5px 0.5px 2px hsl(var(--drop-light-primary)/0.5), inset 1px -1px 3px hsl(var(--drop-bright-primary)/0.5), inset -2px 2px 5px hsl(var(--drop-fade-primary)/0.75), 0 0 0.5px 1px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgb(255, 255, 255);
}
.pageHeader .groupHeading .activeList .buttonText {
  color: var(--ion-text-primary);
}
.pageHeader .groupHeading .activeList .count {
  color: var(--ion-text-danger);
  background: var(--ion-color-danger);
}
.pageHeader .groupHeading .inActiveList {
  background-position: 0 100%;
  transform: scale(0.975);
  backdrop-filter: blur(5px) brightness(0.9) saturate(120%) contrast(1.3);
  box-shadow: var(--shadow-glass-anim), inset -0.5px 0.5px 2px rgba(0, 0, 0, 0.05), inset 1px -1px 3px rgba(255, 255, 255, 0.5), inset -2px 2px 5px rgba(0, 0, 0, 0.15), 0 0 0.25px 0.5px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgb(255, 255, 255);
}
.pageHeader .groupHeading .inActiveList .buttonText {
  color: var(--ion-text-white);
}
.pageHeader .groupHeading .inActiveList .count {
  color: var(--ion-text-grey);
  background: var(--ion-color-grey);
}

.smallHeader {
  min-height: calc(6vh + env(safe-area-inset-top));
}
.smallHeader .headerBox {
  height: 0vh;
}
.smallHeader .headerBox .pageHeaderTitle {
  min-height: 6vh;
}
.smallHeader .headerBox .pageHeaderTitle .pageHeaderContent {
  height: 0;
  font-size: 0px;
  width: 90vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.smallHeader .headerBox .pageHeaderBack {
  height: 0vh;
  width: 0vw;
  opacity: 0;
  margin: 0vw;
}
.smallHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainer {
  transform: scale(0.975) rotateX(0deg);
  opacity: 1;
  background-size: 100% 100%;
}
.smallHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainer .pageHeaderSoloContent {
  color: var(--ion-text-primary);
}
.smallHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainerBig {
  transform: scale(0.5) rotateX(0deg);
  opacity: 0;
  background-size: 100% 100%;
}
.smallHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainerBig .pageHeaderSoloContent {
  color: var(--ion-text-primary);
}
.smallHeader .headerBox .groupHeaderBack {
  margin: 0 1vw;
  height: 6vh;
  width: calc(6vh - 2vw);
  fill: var(--ion-text-primary);
  opacity: 1;
}
.smallHeader .groupHeading {
  height: 6vh;
  transform: scale(0.9);
}
.smallHeader .groupHeading .groupHeaderBack {
  margin: 0 1vw;
  height: 6vh;
  width: calc(6vh - 2vw);
  fill: var(--ion-text-primary);
  opacity: 1;
}

.bigHeader {
  min-height: calc(12vh + env(safe-area-inset-top));
}
.bigHeader .headerBox {
  height: 6vh;
}
.bigHeader .headerBox .pageHeaderTitle {
  min-height: 6vh;
}
.bigHeader .headerBox .pageHeaderTitle .pageHeaderContent {
  height: 6vh;
  font-size: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bigHeader .headerBox .pageHeaderBack {
  height: 6vh;
  opacity: 1;
  margin: 0 1vw;
  width: calc(6vh - 2vw);
}
.bigHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainer {
  transform: scale(0.5) rotateX(0deg);
  backdrop-filter: none;
  box-shadow: none;
  background-size: 100% 0%;
  opacity: 0;
}
.bigHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainer .pageHeaderSoloContent {
  color: var(--ion-text-primary);
}
.bigHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainerBig {
  transform: scale(0.975) rotateX(0deg);
  backdrop-filter: none;
  box-shadow: none;
  background-size: 100% 0%;
  opacity: 1;
}
.bigHeader .headerBox .pageHeaderSoloTitle .pageHeaderSoloTitleContainerBig .pageHeaderSoloContent {
  color: var(--ion-text-primary);
}
.bigHeader .headerBox .groupHeaderBack {
  margin: 0 1vw;
  height: 6vh;
  width: calc(6vh - 2vw);
  opacity: 1;
}
.bigHeader .groupHeading {
  height: 6vh;
  transform: scale(1);
}
.bigHeader .groupHeading .groupHeaderBack {
  margin: 0vw;
  width: 0vw;
  height: 0vh;
  opacity: 0;
}
.pageContainer {
  padding-top: calc(15vh + env(safe-area-inset-top));
  padding-bottom: calc(22vw + env(safe-area-inset-bottom));
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-header/app-header.component.scss"],"names":[],"mappings":"AAAA;EACC,6BAAA;EACA,UAAA;EACA,uBAAA;AACD;;AAEA;EACC,eAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AACD;;AAEA;EACC,wBAAA;EACA,UAAA;EACA,gCAAA;EACA,2BAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,mCAAA;EACA,qGAAA;EACA,6GAAA;AACD;;AAEA;EACC,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,gCAAA;EACA,gBAAA;EACA,qCAAA;AACD;AACC;EAEC,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,WAAA;EACA,gCAAA;EACA,YAAA;AADF;AAGE;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AADH;AAIG;EACC,gCAAA;EACA,eAAA;AAFJ;AAME;EACC,kBAAA;EACA,gCAAA;AAJH;AAOE;EACC,sBAAA;EAGA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EAEA,OAAA;AAVH;AAYG;EACC,2HAAA;EACA,4BAAA;EACA,2BAAA;EACA,gCAAA;EACA,wBAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;AAVJ;AAYI;EACC,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EAEA,gCAAA;EAEA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAZL;AAgBG;EACC,uBAAA;EACA,gCAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,wBAAA;AAdJ;AAgBI;EACC,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EAEA,gCAAA;EACA,gBAAA;AAfL;AAoBE;EACC,kBAAA;EACA,gCAAA;AAlBH;AAyBC;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,gCAAA;AAvBF;AAyBE;EACC,kBAAA;EACA,gCAAA;AAvBH;AA0BE;EACC,eAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,uEAAA;EACA,gCAAA;AAxBH;AA0BG;EACC,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EACA,gCAAA;EACA,gBAAA;AAxBJ;AA4BG;EACC,mBAAA;EACA,cAAA;EACA,aAAA;AA1BJ;AA8BE;EACC,yBAAA;EACA,4RAAA;AA5BH;AA8BG;EACC,8BAAA;AA5BJ;AA+BG;EACC,6BAAA;EACA,mCAAA;AA7BJ;AAkCE;EACC,2BAAA;EACA,uBAAA;EACA,uEAAA;EACA,kPAAA;AAhCH;AAkCG;EACC,4BAAA;AAhCJ;AAmCG;EACC,2BAAA;EACA,iCAAA;AAjCJ;;AAyCA;EACC,gDAAA;AAtCD;AAwCC;EACC,WAAA;AAtCF;AAwCE;EACC,eAAA;AAtCH;AAwCG;EACC,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtCJ;AA4CE;EACC,WAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AA1CH;AA8CG;EACC,qCAAA;EACA,UAAA;EACA,0BAAA;AA5CJ;AA8CI;EACC,8BAAA;AA5CL;AAgDG;EACC,mCAAA;EACA,UAAA;EACA,0BAAA;AA9CJ;AAgDI;EACC,8BAAA;AA9CL;AAmDE;EACC,aAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;AAjDH;AAuDC;EACC,WAAA;EACA,qBAAA;AArDF;AAuDE;EACC,aAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;AArDH;;AA0DA;EAEC,iDAAA;AAxDD;AA4DC;EACC,WAAA;AA1DF;AA4DE;EACC,eAAA;AA1DH;AA6DG;EACC,WAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3DJ;AA+DE;EACC,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AA7DH;AAiEG;EAEC,mCAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;EACA,UAAA;AAhEJ;AAkEI;EACC,8BAAA;AAhEL;AAoEG;EAEC,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;EACA,UAAA;AAnEJ;AAqEI;EACC,8BAAA;AAnEL;AAwEE;EACC,aAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AAtEH;AA0EC;EACC,WAAA;EACA,mBAAA;AAxEF;AA0EE;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAxEH;AAsFA;EACC,kDAAA;EACA,wDAAA;AApFD","sourcesContent":[".headerRelative:host .pageHeader {\n\tposition: relative !important;\n\tpadding: 0;\n\tbackground: transparent;\n}\n\n:host {\n\tposition: fixed;\n\ttop: 0;\n\twidth: 100vw;\n\tmin-height: 12vh;\n\tbackground: transparent;\n\tz-index: 999;\n}\n\n.blurrer {\n\ttransform: translateY(0);\n\topacity: 1;\n\ttransition: all 0.3s ease-in-out;\n\tbackdrop-filter: blur(15px);\n\twidth: 100vw;\n\tdisplay: block;\n\tposition: fixed;\n\ttop: 0vw;\n\tleft: 0;\n\tz-index: 99;\n\t-webkit-backdrop-filter: blur(15px);\n\tmask-image: linear-gradient(to bottom, black 0%, rgb(0, 0, 0, 1) 0%, rgb(0, 0, 0, 1) 50%, transparent 100%);\n\t-webkit-mask-image: linear-gradient(to bottom, black 0%, rgb(0, 0, 0, 1) 0%, rgb(0, 0, 0, 1) 50%, transparent 100%);\n}\n\n.pageHeader {\n\tbackground: transparent;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: flex-end;\n\tflex-direction: column;\n\twidth: 100vw;\n\tmargin: 0;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\ttransition: all 0.3s ease-in-out;\n\tborder-radius: 0;\n\tpadding-top: env(safe-area-inset-top);\n\n\t.headerBox {\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\t// flex-direction: row;\n\t\twidth: 100%;\n\t\ttransition: all 0.3s ease-in-out;\n\t\tz-index: 999;\n\n\t\t.pageHeaderTitle {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tflex-direction: column;\n\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\twidth: 100%;\n\t\t\tcolor: var(--ion-text-primary);\n\t\t\ttext-align: center;\n\t\t\tpadding: 0 10vw 0vw 0vw;\n\t\t\theight: 6vh;\n\n\n\t\t\t.pageHeaderContent {\n\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\t\t}\n\n\t\t.pageHeaderBack {\n\t\t\tposition: relative;\n\t\t\ttransition: all 0.3s ease-in-out;\n\t\t}\n\n\t\t.pageHeaderSoloTitle {\n\t\t\tmargin: 0 10vw 0vw 0vw;\n\t\t\t// width: 100%;\n\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\ttext-align: center;\n\t\t\t// border-radius: 10px;\n\t\t\tflex-direction: row;\n\t\t\t// --border-width: clamp(1px, 0.0625em, 4px);\n\t\t\tcursor: pointer;\n\t\t\tposition: relative;\n\t\t\tpointer-events: auto;\n\t\t\tz-index: 3;\n\n\t\t\tflex: 1;\n\n\t\t\t.pageHeaderSoloTitleContainer {\n\t\t\t\tbackground: linear-gradient(180deg, var(--ion-more-primary) 0%, var(--ion-half-primary) 50%, var(--ion-clear-primary) 100%);\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tbackground-position: 0 100%;\n\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\ttransform-origin: center;\n\t\t\t\tpadding: 0;\n\t\t\t\tborder-radius: 30px;\n\t\t\t\theight: 4vh;\n\n\t\t\t\t.pageHeaderSoloContent {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tuser-select: none;\n\t\t\t\t\t-webkit-user-select: none;\n\t\t\t\t\t-moz-user-select: none;\n\t\t\t\t\t-ms-user-select: none;\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\t\t// text-shadow: 0.1em 0.15em 0.05em rgba(0, 0, 0, 0.2);\n\t\t\t\t\ttransition: all 0.3s ease-in-out;\n\n\t\t\t\t\tpadding: 1vw 5vw;\n\t\t\t\t\tmin-width: 60vw;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.pageHeaderSoloTitleContainerBig {\n\t\t\t\tbackground: transparent;\n\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\tpadding: 0;\n\t\t\t\tborder-radius: 30px;\n\t\t\t\theight: 4vh;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\ttransform-origin: center;\n\n\t\t\t\t.pageHeaderSoloContent {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tuser-select: none;\n\t\t\t\t\t-webkit-user-select: none;\n\t\t\t\t\t-moz-user-select: none;\n\t\t\t\t\t-ms-user-select: none;\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\t\t// text-shadow: 0.1em 0.15em 0.05em rgba(0, 0, 0, 0.2);\n\t\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\t\tpadding: 1vw 2vw;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.groupHeaderBack {\n\t\t\tposition: relative;\n\t\t\ttransition: all 0.3s ease-in-out;\n\t\t}\n\n\n\t}\n\n\n\t.groupHeading {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-direction: row;\n\t\twidth: calc(100vw - 2vh);\n\t\ttext-align: center;\n\t\tz-index: 998;\n\t\tmargin: 1vh;\n\t\tgap: 1vh;\n\t\ttransition: all 0.3s ease-in-out;\n\n\t\t.groupHeaderBack {\n\t\t\tposition: relative;\n\t\t\ttransition: all 0.3s ease-in-out;\n\t\t}\n\n\t\t.groupHeadingTitle {\n\t\t\tmax-width: 75vw;\n\t\t\twidth: 100%;\n\t\t\theight: 5vh;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\ttext-align: center;\n\t\t\tflex-direction: row;\n\t\t\tcursor: pointer;\n\t\t\tposition: relative;\n\t\t\tpointer-events: auto;\n\t\t\tz-index: 3;\n\t\t\tbackdrop-filter: blur(5px) brightness(0.9) saturate(120%) contrast(1.3);\n\t\t\ttransition: all 0.3s ease-in-out;\n\n\t\t\t.buttonText {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tuser-select: none;\n\t\t\t\t-webkit-user-select: none;\n\t\t\t\t-moz-user-select: none;\n\t\t\t\t-ms-user-select: none;\n\t\t\t\tletter-spacing: 1px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 14px;\n\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\ttransition: all 0.3s ease-in-out;\n\t\t\t\tpadding: 1vw 2vw;\n\t\t\t}\n\n\n\t\t\t.count {\n\t\t\t\tborder-radius: 20px;\n\t\t\t\tpadding: 0 2vw;\n\t\t\t\tmargin: 0 2vw;\n\t\t\t}\n\t\t}\n\n\t\t.activeList {\n\t\t\tbackground-position: 0 0%;\n\t\t\tbox-shadow: var(--shadow-glass-anim-end), inset -0.5px 0.5px 2px hsl(var(--drop-light-primary)/0.5), inset 1px -1px 3px hsl(var(--drop-bright-primary)/0.5), inset -2px 2px 5px hsl(var(--drop-fade-primary)/0.75), 0 0 0.5px 1px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgba(255, 255, 255, 1);\n\n\t\t\t.buttonText {\n\t\t\t\tcolor: var(--ion-text-primary);\n\t\t\t}\n\n\t\t\t.count {\n\t\t\t\tcolor: var(--ion-text-danger);\n\t\t\t\tbackground: var(--ion-color-danger);\n\n\t\t\t}\n\t\t}\n\n\t\t.inActiveList {\n\t\t\tbackground-position: 0 100%;\n\t\t\ttransform: scale(0.975);\n\t\t\tbackdrop-filter: blur(5px) brightness(0.9) saturate(120%) contrast(1.3);\n\t\t\tbox-shadow: var(--shadow-glass-anim), inset -0.5px 0.5px 2px rgba(0, 0, 0, 0.05), inset 1px -1px 3px rgba(255, 255, 255, 0.5), inset -2px 2px 5px rgba(0, 0, 0, 0.15), 0 0 0.25px 0.5px inset rgba(255, 255, 255, 0.5), 0 0 0 0 rgba(255, 255, 255, 1);\n\n\t\t\t.buttonText {\n\t\t\t\tcolor: var(--ion-text-white);\n\t\t\t}\n\n\t\t\t.count {\n\t\t\t\tcolor: var(--ion-text-grey);\n\t\t\t\tbackground: var(--ion-color-grey);\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n\n.smallHeader {\n\tmin-height: calc(6vh + env(safe-area-inset-top));\n\n\t.headerBox {\n\t\theight: 0vh;\n\n\t\t.pageHeaderTitle {\n\t\t\tmin-height: 6vh;\n\n\t\t\t.pageHeaderContent {\n\t\t\t\theight: 0;\n\t\t\t\tfont-size: 0px;\n\t\t\t\twidth: 90vw;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\n\n\t\t}\n\n\t\t.pageHeaderBack {\n\t\t\theight: 0vh;\n\t\t\twidth: 0vw;\n\t\t\topacity: 0;\n\t\t\tmargin: 0vw;\n\t\t}\n\n\t\t.pageHeaderSoloTitle {\n\t\t\t.pageHeaderSoloTitleContainer {\n\t\t\t\ttransform: scale(0.975) rotateX(0deg);\n\t\t\t\topacity: 1;\n\t\t\t\tbackground-size: 100% 100%;\n\n\t\t\t\t.pageHeaderSoloContent {\n\t\t\t\t\tcolor: var(--ion-text-primary);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.pageHeaderSoloTitleContainerBig {\n\t\t\t\ttransform: scale(0.5) rotateX(0deg);\n\t\t\t\topacity: 0;\n\t\t\t\tbackground-size: 100% 100%;\n\n\t\t\t\t.pageHeaderSoloContent {\n\t\t\t\t\tcolor: var(--ion-text-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.groupHeaderBack {\n\t\t\tmargin: 0 1vw;\n\t\t\theight: 6vh;\n\t\t\twidth: calc(6vh - 2vw);\n\t\t\tfill: var(--ion-text-primary);\n\t\t\topacity: 1;\n\t\t}\n\n\n\t}\n\n\t.groupHeading {\n\t\theight: 6vh;\n\t\ttransform: scale(0.9);\n\n\t\t.groupHeaderBack {\n\t\t\tmargin: 0 1vw;\n\t\t\theight: 6vh;\n\t\t\twidth: calc(6vh - 2vw);\n\t\t\tfill: var(--ion-text-primary);\n\t\t\topacity: 1;\n\t\t}\n\t}\n}\n\n.bigHeader {\n\t// min-height: calc(15vh + env(safe-area-inset-top));\n\tmin-height: calc(12vh + env(safe-area-inset-top));\n\n\t// background-size: 100% 100%;\n\n\t.headerBox {\n\t\theight: 6vh;\n\n\t\t.pageHeaderTitle {\n\t\t\tmin-height: 6vh;\n\t\t\t// min-height: calc(10vh + env(safe-area-inset-top));\n\n\t\t\t.pageHeaderContent {\n\t\t\t\theight: 6vh;\n\t\t\t\tfont-size: 20px;\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t}\n\n\t\t.pageHeaderBack {\n\t\t\theight: 6vh;\n\t\t\topacity: 1;\n\t\t\tmargin: 0 1vw;\n\t\t\twidth: calc(6vh - 2vw);\n\t\t}\n\n\t\t.pageHeaderSoloTitle {\n\t\t\t.pageHeaderSoloTitleContainer {\n\t\t\t\t// background-position: 0 100%;\n\t\t\t\ttransform: scale(0.5) rotateX(0deg);\n\t\t\t\tbackdrop-filter: none;\n\t\t\t\tbox-shadow: none;\n\t\t\t\tbackground-size: 100% 00%;\n\t\t\t\topacity: 0;\n\n\t\t\t\t.pageHeaderSoloContent {\n\t\t\t\t\tcolor: var(--ion-text-primary);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.pageHeaderSoloTitleContainerBig {\n\t\t\t\t// background-position: 0 100%;\n\t\t\t\ttransform: scale(0.975) rotateX(0deg);\n\t\t\t\tbackdrop-filter: none;\n\t\t\t\tbox-shadow: none;\n\t\t\t\tbackground-size: 100% 00%;\n\t\t\t\topacity: 1;\n\n\t\t\t\t.pageHeaderSoloContent {\n\t\t\t\t\tcolor: var(--ion-text-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.groupHeaderBack {\n\t\t\tmargin: 0 1vw;\n\t\t\theight: 6vh;\n\t\t\twidth: calc(6vh - 2vw);\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t.groupHeading {\n\t\theight: 6vh;\n\t\ttransform: scale(1);\n\n\t\t.groupHeaderBack {\n\t\t\tmargin: 0vw;\n\t\t\twidth: 0vw;\n\t\t\theight: 0vh;\n\t\t\topacity: 0;\n\t\t\t// left: 0vw;\n\t\t\t// top: calc(2vh + env(safe-area-inset-top));\n\t\t\t// z-index: 19099;\n\t\t}\n\n\t\t.groupHeadingTitle {}\n\n\t\t.activeList {}\n\n\t\t.inActiveList {}\n\t}\n}\n\n.pageContainer {\n\tpadding-top: calc(15vh + env(safe-area-inset-top));\n\tpadding-bottom: calc(22vw + env(safe-area-inset-bottom));\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
